import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import {
  BukTicketContents,
  BukTicketContentsType,
  BukTicketIssueData,
  BukTicketPublicationMethod,
  BukTicketSenderInfo,
} from '../../models/buk-ticket.model';
import { User } from '../../../user.model';

import {
  EmailTicketFormComponent,
  getDefaultEmailMessage,
  getDefaultEmailTitle,
} from '../email-ticket-form/email-ticket-form.component';
import { LinkTicketFormComponent } from '../link-ticket-form/link-ticket-form.component';

import { TicketService } from '../../services/ticket.service';
import { UserService } from '../../../user.service';

@Component({
  selector: 'app-buk-ticket-issuer',
  templateUrl: './buk-ticket-issuer.component.html',
  styleUrls: ['./buk-ticket-issuer.component.scss'],
})
export class BukTicketIssuerComponent {
  @Input() set publicationMethod(
    publicationMethod: BukTicketPublicationMethod
  ) {
    this._publicationMethod = publicationMethod;
    this.formInvaild =
      publicationMethod === 'email'
        ? this.emailTicketForm?.ticketFormGroup.invalid
        : this.linkTicketForm?.ticketFormGroup.invalid;
  }
  @Input() email: string;
  @Input() name: string;
  @Input() logo: string;
  @Input() gaTrackingId: string;
  @Input() contentsType: BukTicketContentsType;
  @Input() contents: BukTicketContents;
  @Input() isUnlimitedTicket: boolean;
  @Input() disableIssue: boolean;
  @Input() credit: number;
  @Input() set senderId(senderId: string) {
    if (!senderId) {
      return;
    }

    this._senderId = senderId;

    this.updateSenderInfo();
  }

  @Output() issueTicket = new EventEmitter<BukTicketIssueData>();

  @ViewChild('emailTicketForm')
  emailTicketForm: EmailTicketFormComponent;

  @ViewChild('linkTicketForm')
  linkTicketForm: LinkTicketFormComponent;

  public focusedInput: string;
  public formInvaild = true;

  public _senderId: string;
  public senderInfo: BukTicketSenderInfo = {
    name: '',
    email: '',
    logo_image_url: '',
  };

  public ticketData: BukTicketIssueData;
  public _publicationMethod: BukTicketPublicationMethod;

  public user: User;

  public notEnoughCredits = false;

  constructor(
    private ticketService: TicketService,
    private userService: UserService
  ) {
    this.user = this.userService.getCurrentUser();
  }

  updateSenderInfo(): void {
    this.ticketService.getSenderInfo(this._senderId).subscribe((res) => {
      this.senderInfo = {
        name: res.name || this.name,
        email: res.email || this.email,
        logo_image_url: res.logo_image_url || this.logo,
      };
    });
  }

  updateTicketData(): void {
    const formData =
      this._publicationMethod === 'email'
        ? this.emailTicketForm.ticketFormGroup.getRawValue()
        : this.linkTicketForm.ticketFormGroup.getRawValue();

    if (!formData.emailTitle) {
      formData.emailTitle = getDefaultEmailTitle(
        formData.language,
        this.senderInfo.name
      );
    }

    if (!formData.message) {
      formData.message = getDefaultEmailMessage(formData.language);
    }

    if (!formData.sender_name) {
      formData.sender_name = this.senderInfo.name;
    }

    if (!formData.sender_email) {
      formData.sender_email = this.senderInfo.email;
    }

    if (!formData.sender_logo_image_url) {
      formData.sender_logo_image_url = this.senderInfo.logo_image_url;
    }

    if (this.credit !== undefined && this.credit !== -1) {
      this.checkAvailableTicketCount(formData);
    }

    this.ticketData = formData;
  }

  checkAvailableTicketCount(formData: BukTicketIssueData): void {
    let numberToUse;
    let formControl;

    if (this._publicationMethod === 'email') {
      numberToUse =
        formData.email !== '' ? formData.email.split(',').length : 0;
      formControl = this.emailTicketForm.ticketFormGroup.get('email');
    } else {
      numberToUse = formData.count;
      formControl = this.linkTicketForm.ticketFormGroup.get('count');
    }

    if (numberToUse > this.credit) {
      this.notEnoughCredits = true;
      formControl.setErrors({ notEnoughCreditsError: true });
    } else {
      this.notEnoughCredits = false;
    }
  }

  onIssueTicketClick(): void {
    this.issueTicket.emit(this.ticketData);
  }

  updateTicketForm(preserveFormData: boolean): void {
    if (preserveFormData) {
      this.emailTicketForm.resetEmails();
    } else {
      this._publicationMethod === 'email'
        ? this.emailTicketForm.resetTicketFormGroup()
        : this.linkTicketForm.resetTicketFormGroup();

      this.updateSenderInfo();

      this.formInvaild = true;
    }
  }
}
